module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-1154c908c81d4a4051d8e9b7147ec766.png";